// src/components/ui/Badge.jsx
import React from "react";

/**
 * Einfacher, wiederverwendbarer Badge.
 * - className wird an das span weitergereicht (Tailwind utility classes).
 * - children ist der Badge-Inhalt.
 */
export function Badge({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${className}`}
      role="status"
      aria-label="badge"
    >
      {children}
    </span>
  );
}

// Default export für einfachen Import: `import Badge from "../components/ui/Badge"`
export default Badge;
